import {
  TRIP_REQUIRED_FIELD_OPTION_VALUES,
  tripRequiredFieldOptions,
} from './PayerSpecificSettings/PayerTripRequiredFieldSettings/tripRequiredFieldOptions';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';


export const payerRequiredTripFieldToOption = (requiredField: any) => {
  let key: TRIP_REQUIRED_FIELD_OPTION_VALUES;
  if (requiredField === null || requiredField === undefined) {
    key = TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT;
  } else {
    key = requiredField
      ? TRIP_REQUIRED_FIELD_OPTION_VALUES.YES
      : TRIP_REQUIRED_FIELD_OPTION_VALUES.NO;
  }

  return tripRequiredFieldOptions.find(
    (option) => option.value === key
  ) as SelectOption;
};
